import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EmployeeAssociationSubmit, EmployeeAssociationVerbose } from '@app/modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-details/components/employee-associations/models/employee-association.model';
import { catchError, map } from 'rxjs/operators';
import { api_routes } from '@app/consts';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EmployeeAssociationService {

  constructor(private http: HttpClient, private envService: EnvironmentService) {}

  getAssociations(employeeId: string, take?: number, skip?: number): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.ASSOCIATIONS}`, {
      headers: headers,
      params: params
    })
    .pipe(
      catchError(err => throwError(err)),
      map(res => {
        let data = {
          data: res.data,
          total: res.total
        }

        return data;
      })
    );
  }

  deleteAssociation(employeeId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.ASSOCIATIONS}/${id}`, {
      headers: headers
    });
  }

  getAssociation(employeeId: string, id: string): Observable<EmployeeAssociationVerbose> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.ASSOCIATIONS}/${id}`, {
      headers: headers
    });
  }

  updateAssociation(employeeId: string, employeeAssociation: EmployeeAssociationSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.ASSOCIATIONS}/${employeeAssociation.id}`, employeeAssociation, {
      headers: headers
    });
  }

  createAssociation(employeeId: string, employeeAssociation: EmployeeAssociationSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.ASSOCIATIONS}`, employeeAssociation, {
      headers: headers
    });
  }
}
